export default __webpack_public_path__ + "static/media/Web.b57ba951.svg";